import TimerProvider from 'containers/Header/context/Timer/Provider'
import { selectBasketIsEmpty } from 'containers/OrderDetails/basketSlice'
import BasketPopup from 'containers/Header/basket/Popup'
import BasketIcon from 'containers/Header/basket/Icon'
import LoginPopup from 'containers/Login/LoginPopup'
import useTranslation from 'hooks/useTranslation'
import { LOCATION_STATES } from 'utils/constants'
import usePopupState from 'hooks/usePopupState'
import { useHistory } from 'react-router-dom'
import LanguageSelect from './LanguageSelect'
import { useReduxSelector } from 'store'
import { POPUPS } from 'containers/Home'
import './style.scss'

interface NavbarProps {
  isBasket: boolean
  isCategories: boolean
  isBlack: boolean
  isLoggedIn: boolean
  isGray?: boolean
}

const mm = process.env.REACT_APP_TYPE === 'mm'

const Navbar: React.FC<NavbarProps> = ({ isCategories, isBlack, isLoggedIn, isGray }) => {
  const basketIsEmpty = useReduxSelector(selectBasketIsEmpty)
  const { popup } = usePopupState()
  const isBasketExpanded = popup === 'basket'

  const { push, goBack } = useHistory()
  const { t } = useTranslation('menu')

  return (
    <TimerProvider>
      <div className={`navbar ${isBlack ? '--black' : ''} ${isGray ? '--gray' : ''}`}>
        {mm
          ? <div
            className="navbar__logo"
            onClick={() => {
              push('/map')
            }}>
            <i className='icon icon--logo s24' />
            <span className='--secFont'>Magazynomaty</span>
          </div>
          : <div
            className="navbar__logo"
            onClick={() => {
              push('/')
            }}>
            <i className={`icon icon--${process.env.REACT_APP_TYPE}-full-logo`} />
          </div>}
        <div className="navbar__categories">
          {isCategories && mm && <>
            <span className='--selected'>{t('selfStorage')}</span>
            <span
              onClick={() => {
                push(window.location.pathname, LOCATION_STATES.popup(POPUPS.magMobile))
              }}>
              MagMobile
            </span>
            <span
              onClick={() => {
                push(window.location.pathname, LOCATION_STATES.popup(POPUPS.magStore))
              }}>
              MagStore
            </span>
          </>}
        </div>
        <div className="navbar__buttons">
          <LanguageSelect />
          {isLoggedIn
            ? <button
              className='btn btn--primary'
              onClick={() => push('/')}>
              {t('customerPanel')}
            </button>
            : <button
              className='btn btn--primary'
              onClick={() => push('/login')}>
              {t('logIn')}
            </button>}
          {basketIsEmpty
            ? null
            : <BasketIcon
              action={() => {
                if (isBasketExpanded) goBack()
                else push(window.location.pathname, LOCATION_STATES.popup('basket'))
              }}
            />}
        </div>
      </div>
      {isBasketExpanded && <BasketPopup isDesktop />}
      {popup === 'login' && <LoginPopup />}
    </TimerProvider>)
}

export default Navbar